export default "__VITE_ASSET__CaJILaNJ__"